import React, { useRef, useCallback, useState, useEffect } from 'react';
import { MobilePreviewDragLayer } from './MobilePreviewDragLayer';

export function useMobilePreviewDragLayer({ ref, offsetLeft, body, itemUuid }) {
  const [isShowMobilePreview, setIsShowMobilePreview] = useState(false);
  const timeoutIdForShowPreview = useRef(null);

  const startShowMobilePreview = useCallback(() => {
    timeoutIdForShowPreview.current = setTimeout(() => setIsShowMobilePreview(true), 1000);
  }, []);

  useEffect(() => {
    return () => clearTimeout(timeoutIdForShowPreview.current);
  }, []);

  const cancelShowMobilePreview = useCallback(() => {
    if (timeoutIdForShowPreview.current) {
      clearTimeout(timeoutIdForShowPreview.current);
      timeoutIdForShowPreview.current = null;
    }
    if (isShowMobilePreview) setIsShowMobilePreview(false);
  }, [isShowMobilePreview, timeoutIdForShowPreview]);

  return {
    mobilePreviewDragLayer: isShowMobilePreview ? (
      <MobilePreviewDragLayer
        offsetTop={ref.current && ref.current.getBoundingClientRect().top}
        offsetLeft={offsetLeft}
        itemUuid={itemUuid}
        body={body}
      />
    ) : null,
    startShowMobilePreview,
    cancelShowMobilePreview,
  };
}
